import { DATA_API_SERVICE } from "@/appConfig";
import API from "@/api/api";

export type DashboardDataResponse = {
  currentStatusOfChargers: {
    portsTotal: number;
    available: number;
    unregistered: number;
    unavailable: number;
    inUse: number;
    notReady: number;
    suspended: number;
    needsService: number;
    disconnected: number;
  };
  totalSessions: number;
  uniqueDriversByMonth: {
    date: string;
    value: number;
  }[];
  totalSessionFeesPerDay: {
    date: string;
    value: number;
  }[];
  totalKwhPerDay: {
    date: string;
    value: number;
  }[];
  lifeKwh: number;
  environment: {
    gallonsGasSaved: number;
    greenhouse: number;
    trees: number;
  };
};

export type DashboardLiveKwResponse = {
  softLimit: number;
  hardLimit: number;
  liveKw: number;
};

async function findAll() {
  const response = await API.get<DashboardDataResponse>(`${DATA_API_SERVICE}/dashboard`);
  return response.data;
}

async function liveKw() {
  const response = await API.get<DashboardLiveKwResponse>(`${DATA_API_SERVICE}/live/kw`);
  return response.data;
}

const APIDashboard = {
  findAll,
  liveKw
};

export default APIDashboard;
